import { Modal } from 'antd'
import InvoicedFilter, { invoicedFilterMethod } from '../../../../../../components/Sales/Orders/TableComponents/InvoicedFilter'
import StatusFilter, { statusFilterMethod } from '../../../../../../components/Sales/Orders/TableComponents/StatusFilter'
import DateCell from '../../../../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import { dateFormat, moneyColumn, numVal } from '../../../../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

function VendorList(props) {
  const { list, submitting, visible, onCancel, type } = props
  console.log({ list })
  const columns = {
    purchases: [
      {
        Header: 'Code',
        accessor: 'code',
        width: 200,
        Cell: ({ value, original }) => (
          <Link target={'_blank'} to={`/purchasing/Order/${original._key}/update`}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'Purchases ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Title',
        accessor: 'title',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Company',
        accessor: 'company.fn',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: true,
      },
      { Header: 'Type', accessor: 'type' },
      {
        Header: 'Category',
        accessor: 'category',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Currency',
        accessor: 'currency',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Amount',
        accessor: 'amount',
        Cell: ({ value, original }) => MoneyCell({ value, currency: original.currency }),
      },
      {
        Header: 'Amount USD',
        accessor: 'amountUSD',
        Cell: ({ value }) => MoneyCell({ value, currency: 'USD' }),
      },

      { Header: 'Status', accessor: 'status', Cell: StatusCell },
    ],
    sales: [
      {
        Header: 'Code',
        accessor: 'code',
        Cell: ({ original, value }) => (
          <Link
            target={props.contract && '_blank'}
            to={{
              pathname: `/clients/orders/${original._key}/update`,
            }}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'Enquiry',
        accessor: 'enquiry.code',
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Date',
        accessor: 'date',
        Cell: ({ value }) => value && dateFormat(moment(value)),
      },
      {
        Header: 'Client',
        accessor: 'client.fn',
        width: 300,
      },
      {
        Header: 'Company',
        accessor: 'company.fn',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Account',
        accessor: 'contract.code',
      },
      {
        Header: 'Currency',
        accessor: 'currency',
        hideable: true,
        hideDefault: true,
        style: { textAlign: 'center' },
      },
      // {
      //   Header: 'Amount',
      //   accessor: 'subtotal.net',
      //   hideable: true,
      //   hideDefault: true,
      //   style: {textAlign: 'right'},
      //   Cell: MoneyCell,
      // },
      {
        Header: 'Company',
        accessor: 'company.fn',
        hideDefault: true,
        hideable: true,
        width: 400,
      },
      {
        Header: 'Title',
        accessor: 'title',
        hideDefault: true,
        hideable: true,
        width: 400,
      },

      {
        Header: 'Invoiced',
        accessor: 'invoicing.status',
        hideable: true,
        hideDefault: true,
        filterMethod: invoicedFilterMethod,
        Filter: InvoicedFilter,
      },
      {
        Header: 'Invoiced Date',
        accessor: 'invoicing.date',
        Cell: DateCell,
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'CPO NO',
        accessor: 'cpo.no',
        hideable: true,
      },
      {
        Header: 'Quote Code',
        accessor: 'quote.code',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Reference NO',
        accessor: 'reference.no',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Value (Net)',
        accessor: 'subTotal.net',
        Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
        style: { textAlign: 'right' },
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 150,
        Cell: StatusCell,
        filterMethod: statusFilterMethod,
        Filter: StatusFilter,
      },
      // {
      //   Header: 'File',
      //   accessor: 'file',
      //   Cell: ({value}) =>
      //     value && (
      //       <ViewDownload
      //         view={`${streamUrl}files/${value}?action=view&access_token=${auth.getAccessToken()}`}
      //         download={`${streamUrl}files/${value}?action=download&access_token=${auth.getAccessToken()}`}
      //       />
      //     ),
      // },
    ],
  }
  return (
    <Modal visible={visible} title={type.toUpperCase()} onCancel={onCancel} destroyOnClose={true} width={'75%'}>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        show={{ csv: { fileName: `Client-Report` } }}
        fetching={submitting}
        columns={columns[type]}
      />
    </Modal>
  )
}

export default VendorList
